import { __makeTemplateObject, __rest, __assign } from 'tslib';
import React from 'react';
import { css, styled } from 'styled-components';
import { resets } from '../utils/index.js';

var spanResets = css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n  ", "\n  display: inline;\n  max-width: 100%;\n  word-wrap: normal;\n  word-break: normal;\n  white-space: normal;\n"], ["\n  ", "\n  ", "\n  display: inline;\n  max-width: 100%;\n  word-wrap: normal;\n  word-break: normal;\n  white-space: normal;\n"])), resets.normalize.html, resets.common);
var Span = function Span(_a) {
  var forwardedRef = _a.forwardedRef,
    _b = _a.asProp,
    Component = _b === void 0 ? 'span' : _b,
    passProps = __rest(_a, ["forwardedRef", "asProp"]);
  return /*#__PURE__*/React.createElement(Component, __assign({
    ref: forwardedRef
  }, passProps));
};
var HtmlSpan = styled(Span).withConfig({
  componentId: "sc-1c2dd3r-0"
})(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), spanResets);
var templateObject_1, templateObject_2;

export { HtmlSpan };
//# sourceMappingURL=HtmlSpan.js.map
